import { normalizeRid } from '../../../shared/model/scopeKeys'

export const photoProductKey = (resourceId: string, refKey: string): string =>
  `${normalizeRid(resourceId)}|${refKey.toLowerCase()}`

export const photoOperationKey = (resourceId: string, refKey: string, action: string): string =>
  `${photoProductKey(resourceId, refKey)}|${action}`
